export enum PVBVType {
  PVBVCART = 'PVBVCART',
  PVBVCARTMOBILE = 'PVBVCARTMOBILE',
  PVBVCHECKOUT = 'PVBVCHECKOUT',
  PVBVPDP = 'PVBVPDP',
  PVBVPRODUCTMERCHANDISE = 'PRODUCTMERCHANDISE',
  PVBVSEARCHCARD = 'PVBVSEARCHCARD',
  PVBVABOCHECKBOXCARD = 'PVBVABOCHECKBOXCARD',
  PVBV_FREE_CART_CARD = 'PVBV_FREE_CART_CARD',
}
